export const foregroundColors = {
  /** Dark gray color - for main text */
  primary: '#3F3F3F',

  /** Gray color - for info/description text */
  secondary: 'rgba(123, 130, 138)',

  /** Blue color - for links and accented text to draw attention to. */
  accent: '#585CEA',

  /** White color - for text that is on dark background. */
  primaryInverted: '#ffffff',

  /** Yellow/orange like color - for in progress stuff. */
  inProgress: 'rgb(248, 176, 55)',

  /** Green color - for successfully completed operations. */
  success: '#00C056',

  /** Red color - for errors. */
  error: 'rgb(209, 0, 0)',
};

export const textColors = foregroundColors;

export const backgroundColors = {
  /** Blue color - for drawing attention to call to action components. */
  accent: foregroundColors.accent,

  /** Light blue color - for showing info messages. */
  info: 'rgb(63, 146, 240)',

  /** Yellow/orange like color - for in progress stuff. */
  inProgress: 'rgb(248, 176, 55)',

  /** Green color - for successfully completed operations. */
  success: '#00C056',

  /** Red color - for errors. */
  error: 'rgb(209, 0, 0)',

  /** Bluish gray - for currently selected/active items (eg. navigation). Lighter than selected20. */
  selected: 'rgb(241, 243, 248)',

  /** Transparent bluish color - for currently selected/active items. */
  selected20: 'rgba(88, 92, 234, 0.2)',

  /** Light background - for light theme. */
  light: foregroundColors.primaryInverted,

  /** Translucent white - for light overlay. */
  light70: 'rgba(255, 255, 255, 0.7)',

  /** Opaque-ish white - for light overlay. */
  light90: 'rgba(255, 255, 255, 0.9)',

  /** Translucent dark color: for adding shadow effects around components. */
  shadow: 'rgba(194, 207, 221, 0.5)',

  /** Dark gray - for dark backgrounds. */
  dark: foregroundColors.primary,

  /** Light gray */
  lightGray: 'rgb(242, 244, 245)',

  /** Gray */
  gray: 'rgba(191, 201, 212, 1)',

  /** Translucent dark color - for dark overlays. */
  dark35: 'rgba(0, 0, 0, 0.35)',
};

export const boxShadows = {
  gray: `0 2px 10px ${backgroundColors.gray}`,
};

export const theme = {
  colors: { ...foregroundColors, ...backgroundColors },
};

export const fontFamily = "'Roboto', sans-serif";

export type ForegroundColor = keyof typeof foregroundColors;
export type BackgroundColor = keyof typeof backgroundColors;
export type Color = ForegroundColor | BackgroundColor;
